import {
  Dictionary
} from "./Dictionary";
import {
  slots_config
} from "./slots_config";
import {common_utils} from "../src/components/common/common_utils";

function slots_utils() {

}

slots_utils.prototype.showSlotsFreeBlock = function(free_id, map, remain_free_count, sum_rows = 3, sum_colums = 5)
{
  var free_count = this.getFreeCount(free_id, map, sum_rows, sum_colums);
  return free_count >= remain_free_count;
}

slots_utils.prototype.showSlotsFreeBlockTable = function(free_id, map,remain_free_count, table = [4, 5, 5, 5, 4])
{
  var free_count = this.getFreeCountTable(free_id, map, table);
  console.log("showSlotsFreeBlockTable"+free_count);
  return free_count >= remain_free_count;
}

slots_utils.prototype.getFreeCount = function(free_id, map, sum_rows, sum_columns)
{
  var free_count = 0;
  var dict = new Dictionary();
  var result_colum_array = this.convertSingleArrayToDouble(map, sum_rows, sum_columns);

  if (result_colum_array.length === 0)
  {
    return 0;
  }
  for (let i = 0; i < result_colum_array.length; ++i)
  {
    for (let j = 0; j < result_colum_array[i].length; ++j)
    {
      if (result_colum_array[i][j] == free_id)
      {
          free_count++;
      }
    }
  }
  return free_count;
}

slots_utils.prototype.getFreeCountTable = function(free_id, map, table = [4, 5, 5, 5, 4])
{
    let free_count = 0;
    let result_colum_array = this.convertSingleArrayToDoubleTable(map, table);
    if (result_colum_array.length === 0)
    {
        return free_count;
    }

    for (let i = 0; i < result_colum_array.length; ++i)
    {
      for (let j = 0; j < result_colum_array[i].length; ++j)
      {
        if (result_colum_array[i][j] === free_id)
        {
          free_count++;
        }
      }
    }
    return free_count;
}

slots_utils.prototype.showSlotsWinLine = function(game_id, map, remain_free_count, sum_rows = 3, sum_columns = 5)
{
  var is_free = remain_free_count && remain_free_count > 0;
  return this.getWinItemsIndex(map, sum_rows, sum_columns, is_free, game_id);
}

slots_utils.prototype.getWinItemsIndex = function(map, sum_rows, sum_columns, is_free, game_id)
{
  var dict = new Dictionary();
  var result_colum_array = this.convertSingleArrayToDouble(map, sum_rows, sum_columns);
  return this.getWinItemResultArray(dict,result_colum_array, game_id, is_free);
  // if (result_colum_array.length == 0)
  // {
  //   return dict;
  // }
  //
  // var first_column = result_colum_array[0];
  //
  // for (var i = 0; i < first_column.length; ++i)
  // {
  //   if (dict.safeGetObject(first_column[i]))
  //   {
  //     continue;
  //   }
  //
  //   var win_item = [];
  //   var win_item_item = [];
  //   var index = 0;
  //   for (var j = 0; j < result_colum_array.length; ++j)
  //   {
  //     var compare_colum = result_colum_array[j];
  //     win_item_item = [];
  //     for (var p = 0; p < compare_colum.length; ++p)
  //     {
  //       if (this.isSameItem(is_free, first_column[i], compare_colum[p], game_id))
  //       {
  //         index = j + p * sum_columns;
  //         win_item_item.push(index);
  //       }
  //     }
  //     if (win_item_item.length == 0)
  //     {
  //       break;
  //     }
  //     win_item.push(win_item_item);
  //   }
  //   if (win_item.length > 2)
  //   {
  //     dict.setObject(first_column[i], win_item);
  //   }
  // }
  // return dict;
}

slots_utils.prototype.getWinItemResultArray = function(dict,result_colum_array,game_id,is_free)
{
  console.log(result_colum_array);
  if (result_colum_array.length === 0)
  {
    return dict;
  }
  let first_column = result_colum_array[0];

  for (let i = 0; i < first_column.length; ++i)
  {
    if (dict.safeGetObject(first_column[i]))
    {
      continue;
    }
    let win_item = [];
    let win_item_item = [];
    let index = 0;
    let sum_columns = result_colum_array.length;
    for (let j = 0; j < result_colum_array.length; ++j)
    {
      var compare_colum = result_colum_array[j];
      win_item_item = [];
      for (let p = 0; p < compare_colum.length; ++p)
      {
        if (this.isSameItem(is_free, first_column[i], compare_colum[p], game_id))
        {
          index = j + p * sum_columns;
          win_item_item.push(index);
        }
      }
      if (win_item_item.length === 0)
      {
        break;
      }
      win_item.push(win_item_item);
    }
    if (win_item.length > 2)
    {
      dict.setObject(first_column[i], win_item);
    }
  }
  return dict;
}

slots_utils.prototype.showSlotsWinLineInfo = function(game_id, map, remain_free_count = 0, sum_rows = 3, sum_colums = 5)
{
  var is_free = remain_free_count && remain_free_count > 0;
  return this.getSlotsWinLineInfo(map, sum_rows, sum_colums, is_free, game_id);
}


slots_utils.prototype.getSlotsWinLineInfo = function(win_map, sum_rows, sum_columns, is_free, game_id,callBack)
{
  console.log("getSlotsWinLineInfo");
  let map = this.convertSingleArrayToDouble(win_map, sum_rows, sum_columns);
  let winLines = []
  for (let i = 0; i < sum_columns; i++)
  {
    if (i === 0)
    {
      let first_column = map[i];
      for (let j = 0; j < first_column.length; ++j)
      {
         let index = i + j * sum_columns;
         let list = [{S:map[i][j],L:j,i:index}]
         winLines.push(list)
      }
    }
    else
    {
      let newWinLines = []
      for (let k = 0; k < winLines.length;k++){
        let insert = false
        for (let j = 0 ; j < map[i].length ; j++){
          if (winLines[k].length !== i)
          {
            continue
          }
          let src_type = winLines[k][0].S;
          let compare_type = map[i][j];
          if (this.isSameItem(is_free, src_type, compare_type, game_id))
          {
              let newWinLine = JSON.parse(JSON.stringify(winLines[k]))
              let index = i + j * sum_columns;
              newWinLine.push({S:map[i][j],L:j,i:index})
              newWinLines.push(newWinLine)
              insert = true
          }
        }
        if (insert)
        {
            winLines.splice(k,1)
            k--
        }
      }
      winLines = winLines.concat(newWinLines)
    }
  }
  let result = [];
  for (let i = 0; i < winLines.length;i++)
  {
    let win_line = winLines[i];
    if(callBack == null)
    {
      callBack = function (item)
      {
          return item.length >= 3;
      }
    }
    if(callBack(win_line))
    {
      result.push(win_line);
    }
  }
  return result
}

slots_utils.prototype.showSlotsWinLineInfoTable = function(game_id, map, remain_free_count, table = [4, 5, 5, 5, 4])
{
  console.log("showSlotsWinLinInfoTable")
  var is_free = remain_free_count && remain_free_count > 0;
  return this.getSlotsWinLineInfoTable(map, is_free, game_id,table);
}

slots_utils.prototype.getSlotsWinLineInfoTable = function(win_map, is_free, game_id, table = [4, 5, 5, 5, 4],callBack = null)
{
  var map = this.convertSingleArrayToDoubleTable(win_map, table);
  return this.SlotsWinLineInfoByMap(map, is_free, game_id , callBack);
}

slots_utils.prototype.SlotsWinLineInfoByMap = function(map,is_free, game_id,callBack){

  console.log("SlotsWinLineInfoByMap")
  let winLines = []
  let map_len = map.length;
  var col_index = 0;
  for (let i = 0; i < map_len; i++)
  {
    let map_column = map[i];
    if (i === 0)
    {
      for (let j = 0; j < map_column.length; ++j)
      {
          let list = [{S:map[i][j],L:j,i:j}]
          winLines.push(list)
      }
    }
    else
    {
      let newWinLines = []
      for (let k = 0; k < winLines.length;k++)
      {
        let insert = false
        for (let j = 0 ; j < map[i].length ; j++)
        {
          if (winLines[k].length !== i)
          {
            continue
          }
          let src_type = winLines[k][0].S;
          let compare_type = map[i][j];
          if (this.isSameItem(is_free, src_type, compare_type, game_id))
          {
            let newWinLine = JSON.parse(JSON.stringify(winLines[k]))
            let index = col_index + j;
            newWinLine.push({S:map[i][j],L:j,i:index})
            newWinLines.push(newWinLine)
            insert = true
          }
        }
        if (insert)
        {
          winLines.splice(k,1)
          k--
        }
      }
      winLines = winLines.concat(newWinLines)
    }
    col_index += map_column.length;
  }
  let result = [];
  for (let i = 0; i < winLines.length;i++)
  {
    let win_line = winLines[i];
    if(callBack == null)
    {
      callBack = function (item)
      {
        return item.length >= 3;
      }
    }
    if(callBack(win_line))
    {
      result.push(win_line);
    }
  }
  return result;
}



slots_utils.prototype.isSameItem = function(is_free, src_type, compare_type, game_id) {
  var dict = slots_config.game_config;
  if (!dict) {
    return false;
  }
  var slot_dict = dict.safeGetObject(game_id);
  var config = slot_dict[src_type];
  if (!config) {
    return false;
  }
  var config_str_array = config.split(",");
  for (var i = 0; i < config_str_array.length; ++i) {
    if (config_str_array[i] == compare_type.toString()) {
      return true;
    }
  }
  return false;
}

//将一维数组转为以列为基础的二维数组
slots_utils.prototype.convertSingleArrayToDouble = function(src_array, row, colum) {
  var ret = [];
  for (var i = 0; i < colum; ++i) {
    var child_array = [];
    for (var j = 0; j < row; ++j) {
      child_array.push(src_array[i + j * colum]);
    }
    ret.push(child_array);
  }
  return ret;
}

slots_utils.prototype.convertSingleArrayToDoubleTable = function(src_array, table) {
  var ret = [];
  var col_index = 0;
  for (var i = 0; i < table.length; ++i) {
    var child_array = [];
    for (var j = 0; j < table[i]; ++j) {
      child_array.push(src_array[col_index + j]);
    }
    col_index = col_index + table[i];
    ret.push(child_array);
  }
  return ret;
}

slots_utils.prototype.showSlotsWinLineTable = function(game_id, map, remain_free_count, table = [4, 5, 5, 5, 4]) {
  var is_free = remain_free_count && remain_free_count > 0;
  return this.getSlotsWinLineTable(map, table, is_free, game_id);
}

slots_utils.prototype.getSlotsWinLineTable  = function(map, table, is_free, game_id) {

  var dict = new Dictionary();
  var result_colum_array = this.convertSingleArrayToDoubleTable(map, table);

  if (result_colum_array.length == 0)
  {
    return dict;
  }

  var first_column = result_colum_array[0];

  for (var i = 0; i < first_column.length; ++i)
  {
    if (dict.safeGetObject(first_column[i]))
    {
      continue;
    }
    var win_item = [];
    var win_item_item = [];
    var index = 0;
    var col_index = 0;
    for (var j = 0; j < result_colum_array.length; ++j)
    {
      var compare_colum = result_colum_array[j];
      win_item_item = [];
      for (var p = 0; p < compare_colum.length; ++p)
      {
        if (this.isSameItem(is_free, first_column[i], compare_colum[p], game_id))
        {
          index = col_index + p;
          win_item_item.push(index);
        }
      }
      col_index = col_index + compare_colum.length;

      if (win_item_item.length == 0)
      {
        break;
      }
      win_item.push(win_item_item);
    }
    if (win_item.length > 2)
    {
        dict.setObject(first_column[i], win_item);
    }
  }
  return dict;
}


slots_utils.isFree = function(this1,data)
{
  this1.isfree = common_utils.isFreeTip(data)
}

slots_utils.isExtTip = function(this1,data)
{
  this1.ext = common_utils.isExtTip(data)
}

slots_utils.GetFreeType = function(flag)
{
  // console.log("GetFreeType"+flag)
  if((flag & 4)  === 0)
  {
    return "购买彩金游戏"
  }
  if((flag & 2)  === 0)
  {
    return "免费游戏"
  }
  return "普通游戏"
}

export {
  slots_utils
};





//////////////////
// WEBPACK FOOTER
// ./untils/slots_utils.js
// module id = null
// module chunks = 